<template>
    <span class="d-inline-block change-password">
        <b-btn @click="modalShow = !modalShow" variant="primary" size="sm">
            {{ $t('button.ChangePassword') }}
        </b-btn>
        <b-modal
                ref="changePassword"
                :no-close-on-backdrop="true"
                size="lg"
                :title="$t('pages.ChangePassword')"
                title-tag="h3"
                v-model="modalShow"
        >
            <div class="d-block text-center">
                <div class="alert alert-danger" v-if="error">{{$t(error)}}</div>
                <div class="alert alert-success" v-if="success">{{success}}</div>
                <formly-form :form="form" :model="model" :fields="fields" ref="create"/>
            </div>

            <div slot="modal-footer" class="w-100">
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '')"
                        variant="secondary"
                        @click="modalShow = false"
                        :disabled="disabled"
                >{{$t('button.Close')}}
                </b-btn>
                <b-btn
                        size="sm"
                        :class="(disabled ? 'disabled': '') + ' ml-3'"
                        variant="primary"
                        @click="submit"
                        :disabled="disabled"
                >{{$t('button.Save')}}
                </b-btn>
            </div>
        </b-modal>
    </span>
</template>

<script>
  import validation from '../../utils/preDefinedValidation';
  import { mapActions } from 'vuex';
  import {BButton} from 'bootstrap-vue/src/components/button/button';
  import {BModal} from 'bootstrap-vue/src/components/modal/modal';
  import { ERROR_MESSAGES } from '../../constants';

  export default {
    components: {
      BModal: BModal,
      BBtn: BButton
    },
    data() {
      return {
        modalShow: false,
        disabled: false,
        error: '',
        success: '',
        form: {},
        model: {
          oldPassword: '',
          password: '',
          password_confirmation: ''
        },
        fields: [
          {
            key: 'oldPassword',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.ActualPassword'),
              inputType: 'password'
            },
            required: true
          },
          {
            key: 'password',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.Password'),
              inputType: 'password'
            },
            required: true,
            validators: {
                valid: validation.validPassword
            }
          },
          {
            key: 'password_confirmation',
            type: 'input',
            templateOptions: {
              label: this.$t('fields.ConfirmPassword'),
              inputType: 'password'
            },
            required: true,
            validators: {
              valid: validation.validConfirmationPassword
            }
          }
        ]
      };
    },
    methods: {
      ...mapActions(['changePassword']),
      submit(e) {
        e.preventDefault();
        this.$refs.create.validate()
          .then(() => {
            if (!this.form.$valid) return;
            this.disabled = true;

            this.changePassword(this.model)
              .then(() => {
                this.success = this.$t('profile.changePassword.success');
                setTimeout(() => {
                  this.disabled = false;
                  this.modalShow = false;
                  this.success = '';
                }, 1000);
              })
              .catch(() => {
                this.disabled = false;
                if (e.response.data && e.response.data.message) {
                  this.error = 'errorMessages.' +  e.response.data.message;
                } else {
                  this.error = ERROR_MESSAGES.INTERNAL_SERVER_ERROR;
                }
              });
          });
      }
    }
  };
</script>


<style>
</style>
